/**
 * GENERATED CODE - DO NOT MODIFY
 */
import { Headers, XRPCError } from '@atproto/xrpc'
import { ValidationResult, BlobRef } from '@atproto/lexicon'
import { isObj, hasProp } from '../../../../util'
import { lexicons } from '../../../../lexicons'
import { CID } from 'multiformats/cid'

export interface QueryParams {}

export interface InputSchema {
  wallet: string
  collectibleCid: string
  did?: string
  [k: string]: unknown
}

export interface OutputSchema {
  /** Formatted timestamp gotten back from sphere when requesting a payment */
  createdAt: string
  /** The id returned from Sphere that is unique to this payment */
  paymentId: string
  /** Base-64 encoded transaction */
  serializedTxn: string
  [k: string]: unknown
}

export interface CallOptions {
  headers?: Headers
  qp?: QueryParams
  encoding: 'application/json'
}

export interface Response {
  success: boolean
  headers: Headers
  data: OutputSchema
}

export function toKnownErr(e: any) {
  if (e instanceof XRPCError) {
  }
  return e
}
